import React from 'react'
import {Row,Col} from 'react-bootstrap'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

function EditTemplate2({refreshCustomOrderData,data,checkIfThisLocation}) {
    
    const handleOnDragEnd = (result) =>{
        const { source, destination } = result;
        if (!destination) return;
        let newDraggedData = JSON.parse(JSON.stringify(data));
        //Reordering Item In The Same List
        if (source.droppableId === destination.droppableId) {
            if(newDraggedData[source.droppableId] === undefined || newDraggedData[destination.droppableId] === undefined) return;
            let [reorderedItem] = newDraggedData[source.droppableId].splice(result.source.index, 1);
            newDraggedData[source.droppableId].splice(result.destination.index, 0, reorderedItem);
            refreshCustomOrderData(newDraggedData);
        }
        //Reordering Item In The Different List
        else if (source.droppableId !== destination.droppableId){
            let [reorderedItem] = newDraggedData[source.droppableId].splice(result.source.index, 1);
            newDraggedData[destination.droppableId].splice(result.destination.index, 0, reorderedItem);
            refreshCustomOrderData(newDraggedData);
        }
        else{
            console.log('Unable to make a action')
        }
    }

    return (
        <>
            <div>
                <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Row className="w-100" style={{minWidth:'700px'}}>
                        <Col md="4" className="bg-light py-3">
                            <p className="text-center mt-2">Removed Elements</p>
                            <Droppable droppableId="removedElements">
                                {(provided) => (
                                    <div className="drop-container" style={{minHeight:'150px'}} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                    {data.removedElements.map((element,index) => {
                                        return checkIfThisLocation('removedElements',element) && 
                                            <Draggable key={element+index.toString()} draggableId={index.toString()+100} index={index}>
                                                {(provided) => (
                                                    <div className="p-2" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <div className="d-flex justify-content-between py-2 px-3 bg-white border rounded capitalize">
                                                            <span className="p-md-2 my-auto">{element}</span> 
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>;
                                    })}
                                    {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </Col>
                        <Col md="8" className="mt-3 mt-md-0">
                            <p className="text-left bg-light mb-0 px-3 pt-4">Heading Section</p>
                            <div className="pt-4 px-2 bg-light" style={{paddingBottom:'20px'}}>
                            <Droppable droppableId="header" direction="horizontal">
                                {(provided) => (
                                    <span className="drop-container" style={{ display: 'flex', overflow: 'auto',minHeight:'70px'}} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                    {data.header.map((element,index) => {
                                        return checkIfThisLocation('header',element) && 
                                            <Draggable key={element+index.toString()} draggableId={index.toString()+200} index={index}>
                                                {(provided) => (
                                                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <div className="d-block py-2 px-3 m-3 bg-white border rounded capitalize">
                                                            <div className="p-md-2 my-auto">{element}</div> 
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>;
                                    })}
                                    {provided.placeholder}
                                    </span>
                                )}
                            </Droppable>
                            </div>
                            <Row className="bg-light w-100 mx-auto" style={{borderTop:'1px solid lightgrey',paddingTop:'20px',paddingBottom:'20px'}}>
                                <Col xs="6" style={{borderRight:'1px solid lightgrey'}}>
                                <p>Column 1</p>
                                    <Droppable droppableId="column1">
                                        {(provided) => (
                                            <div className="drop-container" style={{minHeight:'150px'}} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            {data.column1.map((element,index) => {
                                                return checkIfThisLocation('column1',element) && 
                                                    <Draggable key={element+index.toString()} draggableId={index.toString()+300} index={index}>
                                                        {(provided) => (
                                                            <div className="p-2" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                <div className="d-flex justify-content-between py-2 px-3 bg-white border rounded capitalize">
                                                                    <span className="p-md-2 my-auto">{element}</span> 
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>;
                                            })}
                                            {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </Col>
                                <Col xs="6">
                                    <p>Column 2</p>
                                    <Droppable droppableId="column2">
                                        {(provided) => (
                                            <div className="drop-container" style={{minHeight:'150px'}} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            {data.column2.map((element,index) => {
                                                return checkIfThisLocation('column2',element) && 
                                                    <Draggable key={element+index.toString()} draggableId={index.toString()+400} index={index}>
                                                        {(provided) => (
                                                            <div className="p-2" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                <div className="d-flex justify-content-between py-2 px-3 bg-white border rounded capitalize">
                                                                    <span className="p-md-2 my-auto">{element}</span> 
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>;
                                            })}
                                            {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </DragDropContext>
            </div>
        </>
    )
}

export default EditTemplate2
